import { makeAutoObservable, runInAction } from "mobx";

import { getProductTypes, graphqlClient } from "src/api";
import { PRODUCT_TYPE_LIST } from "src/api/graphql-api/product/product.gql";
import { ProductTypeOutput, ProductTypeOutputV2 } from "src/models";
import { createRequest } from "urql";

export class CategoriesStore {
  private _loading = false;
  private _categories: ProductTypeOutput = {
    default: [],
    custom: [],
  };

  private _categoriesV2: ProductTypeOutputV2[] = [];

  public get loading() {
    return this._loading;
  }

  public get categories() {
    return this._categories;
  }

  public get categoriesV2() {
    let localeCode = localStorage.getItem("localeCode") || "en";
    localeCode = localeCode.toLowerCase() === "zh_tw" ? "zh_TW" : localeCode;
    return this._categoriesV2.map((row) => {
      return {
        ...row,
        label: row?.translations ? row.translations[localeCode] : row.name,
      };
    });
  }

  public get defaultCategories() {
    return this._categories.default;
  }

  public get customCategories() {
    return this._categories.custom;
  }

  constructor() {
    makeAutoObservable(this);
  }

  /* Requests ↓ */
  public async loadCategoriesList() {
    runInAction(() => {
      this._loading = true;
    });

    try {
      graphqlClient
        .executeQuery(createRequest(PRODUCT_TYPE_LIST, { version: "v2" }))
        .then((res) => {
          const rows = res?.data?.productTypeList?.data || [];
          runInAction(() => {
            this._categoriesV2 = rows
              .filter((item: ProductTypeOutputV2) => !item?.deactivated)
              .map((row: ProductTypeOutputV2) => {
                const translations = JSON.parse(row.translations);
                return {
                  ...row,
                  translations,
                  label: row.name,
                };
              });
            this._loading = false;
          });
        });
    } catch (e) {
      console.warn("loadCategoriesList", e);
    }
    const { success } = await getProductTypes.getRequest().fetch();

    runInAction(() => {
      if (success) {
        this._categories = success;
      }

      // this._loading = false;
    });
  }
  /* Requests ↑ */

  /* UI State ↓ */
  /* UI State  ↑  */

  /* Helpers ↓ */
  /* Helpers ↑ */
}
